export function usernameOrFullName(user) {
    if (user.username.includes('@') || !user.username || user.username.trim() === '') {
        return user.full_name;
    }
    else
        return user.username;
}
//# sourceMappingURL=user.js.map